<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer v-if="$route.name != 'QuizTaskViewer' && $route.name != 'VideoViewer' && $route.name != 'UploadViewer'" id="footerGlobal" class="the-footer flex-wrap justify-between" :class="classes">
      <span style="color: lightgray ;user-select: none;-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;">COPYRIGHT @ {{ new Date().getFullYear() }} Lateral Scaffolding <span style="user-select: none;-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;" @click="increment" >v2.{{version}}</span> | Powered by <a href="https://DigiCentral.co.za" style="color: #52b75d" target="_blank" rel="nofollow">DigiCentral.co.za</a>. All rights Reserved</span>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    },
    data(){
        return{
            version:0,
        }
    },
    watch:{
        version:function(){
            if(this.version == 10){
                this.$swal.fire(
                    `This Website was built with love`
                );
            }
            if(this.version == 20){
                this.$swal.fire(
                    `You are one persistant person`
                );
            }
            if(this.version == 21){
                this.$swal.fire(
                    `Again really. Please stop`
                );
            }
            if(this.version == 25){
                this.$swal.fire(
                    `Why are you doing this`
                );
            }
            if(this.version == 30){
                this.$swal.fire(
                    `You are really persistant`
                );
            }
            if(this.version == 40){
                this.$swal.fire(
                    `Fine you win have a 🍪`
                );
            }
        }
    },
    methods:{
        increment(){
            this.version++;
        }
    }
}
</script>